/* Seção 04: usa a mecânica compartilhada de ef-accordion.js */
(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-matters]').forEach(function (section) {
      if (section._efMattersBound || !window.EFAccordion) return;
      section._efMattersBound = true;
      window.EFAccordion.attach(section, {
        item: '[data-item]',
        head: '.ef-matters__row',
        body: '.ef-matters__body',
        openClass: 'is-open'
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
